import { ContextConfig } from '../types/context';

export const CONTEXTS: ContextConfig[] = [
  {
    id: 'admin',
    name: 'Panel de Administración',
    description: 'Gestión de usuarios, solicitudes, geografía e indicadores',
    icon: 'landmark',
    requiredRoles: ['Super Admin', 'Admin Nacional', 'Admin Diocesano', 'User Nacional', 'User Diocesano'],
    path: '/admin',
  },
  {
    id: 'lumisial',
    name: 'Gestión de Lumisial',
    description: 'Operación diaria de Lumisiales',
    icon: 'sun',
    requiredRoles: ['Super Admin', 'Admin Nacional', 'Admin Diocesano', 'Admin Local', 'User Nacional', 'User Diocesano', 'User Local'],
    path: '/lumisial',
  },
];

export function getContextConfig(contextId: string): ContextConfig | undefined {
  return CONTEXTS.find(c => c.id === contextId);
}

export function getContextsForRole(rolNombre: string): ContextConfig[] {
  return CONTEXTS.filter(context => context.requiredRoles.includes(rolNombre));
}
